import { defineTemplate } from '../../../utils';

const BASE = `${process.env.REACT_APP_MEDIA_DOMAIN}/brands/assets/DISNEY/templates`;

export const disneyRelated = defineTemplate({
  mode: 'legacy',
  id: 'related',
  clientId: 'DISNEY',
  handlerKey: 'DISNEY',
  title: 'Relacionados',
  disabled: true,
  hiddenFromUI: true,
  thumbnail: {
    url: `${BASE}/thumbnails/relacionados.png`,
    optimizedUrl: `${BASE}/thumbnails/optimized/relacionados.png`,
    hoverVideo: `${BASE}/previews/relacionados.mp4`,

    aspectRatio: 'vertical'
  },
  formFields: []
});
